const productBundleForm = document.querySelector('.product .product-bundle');
const productBundleVariants = productBundleForm.querySelectorAll('label');
const productBundleButton = document.querySelector('buy-buttons .button');
const bundleElements = productBundleForm.querySelectorAll('fieldset input');
const inputProductForm = document.querySelector('.inputProductForm');

const productStickyATC = document.querySelector('.product-sticky-atc');

if (bundleElements) {
  let idBundle = "";
  bundleElements.forEach(el => {
    el.addEventListener('change', () => {
      if (el.checked) idBundle = el.value;
      inputProductForm.value = idBundle;
    })
  });
}

function updateBundleButtonPrice(productPrice){
  const productBundlePrice = productBundleButton.querySelector('#product-bundle-price');
  productBundlePrice.innerHTML = `${productPrice}`;

  /*
  const HTMLToAdd = `<span id="product-bundle-price"></span>`;
  productBundleButton.innerHTML += HTMLToAdd;
  const price = productBundleButton.querySelector('#product-bundle-price').innerHTML = `| ${productPrice}`;
  */

}
updateBundleButtonPrice(productBundleVariants[0].previousElementSibling.dataset.productPrice);

function updateProductSticky(productName, productSubName, productPrice){
  const productStickyName = productStickyATC.querySelector('.informations .name');
  const productStickySubName = productStickyATC.querySelector('.informations .subname');
  const productStickyPrice = productStickyATC.querySelector('.button .button__price');

  productStickyName.innerHTML = `${productName}`;
  productStickySubName.innerHTML = `${productSubName}`;
  productStickyPrice.innerHTML = `${productPrice}`;
}

productBundleVariants.forEach(variant => {
    variant.addEventListener('click', () => {
        
        let input = variant.previousElementSibling;
        if (input && input.tagName.toLowerCase() === 'input') {

          const productName = input.dataset.productName;
          const productSubName = input.dataset.productSubName;
          const productId = input.value;
          const productPrice = input.dataset.productPrice;

          updateBundleButtonPrice(productPrice);
          updateProductSticky(productName, productSubName, productPrice)
        }
    })
})